import { proxyCustomElement, HTMLElement, h, Host } from '@stencil/core/internal/client';

const gSpacerCss = ".g__spacer{box-sizing:border-box;display:flex;align-items:center;width:100%}.g__spacer--white{background-color:#fff}.g__spacer--black{background-color:#000}.g__spacer--gray{background-color:#eee}.g__spacer--mediumGray{background-color:#d9d9d9}.g__spacer--darkGray{background-color:#333333}.g__spacer__horizontal{width:100%;margin:0 1rem;border-style:solid;border-width:1px 0 0}.g__spacer__horizontal--white{border-color:#fff}.g__spacer__horizontal--black{border-color:#000}.g__spacer__horizontal--gray{border-color:#eee}.g__spacer__horizontal--mediumGray{border-color:#d9d9d9}.g__spacer__horizontal--darkGray{border-color:#333333}";
const GSpacerStyle0 = gSpacerCss;

const GSpacer$1 = /*@__PURE__*/ proxyCustomElement(class GSpacer extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.color = 'white';
        this.divider = undefined;
        this.dividerColor = undefined;
        this.height = '32';
        this.dataTestId = undefined;
    }
    validateColor(newValue) {
        if (newValue === 'offWhite' || newValue === 'lightGray') {
            console.warn(`Option '${newValue}' will be depreciated in a future release. Update to use 'gray' or 'white' instead.`);
        }
    }
    render() {
        var _a, _b;
        const baseClass = 'g__spacer';
        const componentClasses = {
            [baseClass]: true,
            [`${baseClass}--${this.color}`]: Boolean(this.color),
        };
        const horizontalBaseClass = `${baseClass}__horizontal`;
        const dividerClasses = {
            [horizontalBaseClass]: true,
            [`${horizontalBaseClass}--${this.dividerColor}`]: Boolean(this.dividerColor),
        };
        return (h(Host, { key: 'f2c0f9a14eb95f7152514ea678fd3b10db19aa3e', class: componentClasses, style: { height: `${this.height}px` }, "data-testid": ((_a = this.dataTestId) === null || _a === void 0 ? void 0 : _a.host) || baseClass }, this.divider && (h("hr", { key: 'e22f353ac7067ac0b5d6f9c445be17b74e84e19f', class: dividerClasses, "data-testid": ((_b = this.dataTestId) === null || _b === void 0 ? void 0 : _b.horizontal) || horizontalBaseClass }))));
    }
    static get watchers() { return {
        "color": ["validateColor"]
    }; }
    static get style() { return GSpacerStyle0; }
}, [0, "g-spacer", {
        "color": [1],
        "divider": [4],
        "dividerColor": [1, "divider-color"],
        "height": [1],
        "dataTestId": [16]
    }, undefined, {
        "color": ["validateColor"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["g-spacer"];
    components.forEach(tagName => { switch (tagName) {
        case "g-spacer":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, GSpacer$1);
            }
            break;
    } });
}

const GSpacer = GSpacer$1;
const defineCustomElement = defineCustomElement$1;

export { GSpacer, defineCustomElement };

//# sourceMappingURL=g-spacer.js.map